import Link from 'next/link';

import { Typography } from 'lighthouse';

import { carInspection, freewayTollsLanding, motorInspection, trafficPlanLanding, vehicleFinesLanding } from '@/constants/routes';

import Reveal from '../Reveal';

import { ArrowLeft, CardPos, Notification, SearchStatus, ShieldTick, Verify } from 'iconsax-react';

const inquiries = [
    {
        id: 1,
        icon: <CardPos size={22} color='#008fff' />,
        title: 'خلافی خودرو',
        description: 'استعلام و پرداخت',
        href: vehicleFinesLanding
    },
    {
        id: 2,
        icon: <ShieldTick size={22} color='#008fff' />,
        title: 'طرح ترافیک',
        description: 'استعلام بدهی',
        href: trafficPlanLanding
    },
    {
        id: 3,
        icon: <Notification size={22} color='#008fff' />,
        title: 'عوارض آزادراهی',
        description: 'استعلام و پرداخت',
        href: freewayTollsLanding
    },
    {
        id: 4,
        icon: <SearchStatus size={22} color='#008fff' />,
        title: 'کارشناسی خودرو',
        description: 'رنگ، بدنه و فنی',
        href: carInspection
    },
    {
        id: 5,
        icon: <Verify size={22} color='#008fff' />,
        title: 'کارشناسی موتورسیکلت',
        description: 'رنگ، بدنه و فنی',
        href: motorInspection
    }
];

const InquiryTouchPoints = () => {
    return (
        <div className='mx-auto mt-6 w-full max-w-6xl px-5'>
            <Reveal>
                <div className='flex items-center justify-between gap-4'>
                    <Typography variant='subtitle2' component='h2' fontWeight={700} color='blackMediumEmphasis'>
                        دیگر خدمات ازکی‌سرویس
                    </Typography>
                    <Link href='/' className='flex shrink-0 items-center gap-1 text-xs font-bold text-primary transition-opacity hover:opacity-80'>
                        همه خدمات
                        <ArrowLeft size={14} color='currentcolor' />
                    </Link>
                </div>
            </Reveal>

            <div className='nice-scroll -mx-5 mt-3 flex gap-3 overflow-x-auto px-5 pb-1 lg:mx-0 lg:grid lg:grid-cols-5 lg:overflow-visible lg:px-0'>
                {inquiries.map((item, index) => (
                    <Reveal key={item.id} delay={index * 90}>
                        <Link
                            href={item.href}
                            className='flex min-w-[200px] items-center gap-3 rounded-lg bg-white px-4 py-3.5 shadow-elevation1 ring-1 ring-black/5
                                transition-shadow duration-300 hover:shadow-elevation2 sm:min-w-0'>
                            <span className='flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10'>{item.icon}</span>
                            <span className='flex flex-col'>
                                <Typography variant='body2' component='span' fontWeight={700} color='blackHighEmphasis'>
                                    {item.title}
                                </Typography>
                                <Typography variant='caption' component='span' color='blackLowEmphasis'>
                                    {item.description}
                                </Typography>
                            </span>
                        </Link>
                    </Reveal>
                ))}
            </div>
        </div>
    );
};

export default InquiryTouchPoints;
